module.exports = __webpack_public_path__ + "static/media/banner1.30d70f88.png";